import React, { useState, useEffect } from "react";
import { Link, useLocation, withRouter } from "react-router-dom";
import { useSelector, connect, useDispatch } from "react-redux";
import {
  isAgent,
  isInternal,
  isVenueAdmin,
  token as tokenSelector,
  token,
} from "modules/auth";
import { currencyFormatter } from "utils";
import {
  ButtonBlack,
  ButtonBrand,
  ButtonSpan,
  ButtonPrimary,
} from "Components/Button";
import RfpProposalDetailModal from "./RfpProposalDetailModal";
import PackagePriceBreakdownModal from "./PackagePriceBreakdownModal";
import RoomsPriceBreakdownModal from "./RoomsPriceBreakdownModal";
import CateringPriceBreakdownModal from "./CateringPriceBreakdownModal";
import AccommodationPriceBreakdownModal from "./AccommodationPriceBreakdownModal";
import CommissionPriceBreakdownModal from "./CommissionPriceBreakdownModal";
import EnquiryStatus from "../../pages/admin/rfp/Confirmation/Components/EnquiryStatus";
import { fetchVatRates } from "../../redux/actions";
import { ENQUIRY_VENUE_DATA_STATUS } from "../../modules/rfp/enquiryVenueDataStatus";
import useService from "../../hooks/useService";
import { getEnquiryById } from "../../services/rfpService";
import AdditionalCostsPriceBreakdownModal from "./AdditionalCostsPriceBreakdownModal";
import { formatDate } from "../../modules/dates";

const Row = ({ dark, title, value }) => {
  return (
    <div
      className="p-2 flex justify-between items-center"
      style={{
        backgroundColor: dark ? "#eaeaea" : "#f9f9f9",
      }}
    >
      <span>{title}</span>
      <span className="font-bold">{value}</span>
    </div>
  );
};

const ImportedApprovedSlide = ({ data, venue }) => {
  const summaryItems = data.proposal_data.summary.summary_items || [];
  const total = summaryItems.find(item => item.step_id === 9) || {};
  return (
    <>
      <div className="mb-5">
        <h2
          className="text-white bg-black font-normal font-body p-3 uppercase"
          style={{ minHeight: "6.7rem" }}
        >
          {venue.name}
        </h2>
        <p
          className="bg-brand text-white font-normal uppercase text-lg flex items-center p-3"
          style={{ minHeight: "5rem" }}
        >
          <EnquiryStatus status={data.status} />
        </p>
        <div
          className="re-16/9 w-full bg-no-repeat bg-cover bg-center"
          style={
            venue.image
              ? {
                  backgroundImage: `url(${window.API}/venues/${venue.slug}/images/${venue.image})`,
                }
              : null
          }
        />
        <div className="flex justify-between p-3 font-normal text-xl mb-2">
          <div>
            <i className="mr-2 fas fa-users" />
            {venue.capacity}
          </div>
          <div>
            <i className="mr-2 fas fa-bed" />
            {venue.bedrooms}
          </div>
          <div>
            <i className="mr-2 fas fa-handshake" />
            {venue.meeting_rooms}
          </div>
        </div>
        <div className="p-3 bg-brand  bg-black text-white">
          <div className={"flex justify-between items-center py-1"}>
            <span className="font-normal">PROPOSAL PRICE</span>
            <span className="font-bold text-xl">
              {currencyFormatter(data.currency.currency_code).format(
                total.total_inc_vat
              )}{" "}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(ImportedApprovedSlide);
